import CodementumUrlPlugin from '@cm-frontend/panel-url';
import { Icon } from '@iconify/vue2';
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import type { VueConstructor } from 'vue';
import VueI18n, { type LocaleMessages } from 'vue-i18n';

import CodementumNavbar from './codementumNavbar.vue';
import cookieJwt from './store/cookieJwt.js';
import storeFacade from './store/index.js';

interface PluginOptions {
  store: {
    registerModule: (name: string, module: unknown) => void;
    [key: string]: unknown;
  };
  axios: unknown;
  i18n?: LocaleMessages;
  storeMerge?: any;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: 2,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false
    }
  }
});

const CodementumNavbarPlugin = {
  install(Vue: VueConstructor, options: PluginOptions) {
    if (!options || !options.store || !options.axios) {
      throw new Error('Please initialise plugin with Vuex store and axios');
    }

    Vue.use(VueI18n);
    const VueAny = Vue as unknown as { options: { i18n?: unknown } };
    if (options.i18n && !VueAny.options.i18n) {
      VueAny.options.i18n = new VueI18n({
        locale: 'en',
        messages: options.i18n
      });
    }

    Vue.use(VueQueryPlugin, { queryClient });
    Vue.use(CodementumUrlPlugin, { store: options.store });
    Vue.component('Icon', Icon);
    options.store.registerModule(
      'CodementumUser',
      storeFacade(options.axios, options.storeMerge)
    );
    cookieJwt(options.store, queryClient);
    Vue.component(CodementumNavbar.name!, CodementumNavbar);
  }
};

export default CodementumNavbarPlugin;
